import { useCallback } from 'react';
import { get } from 'lodash-es';
import { transformVin } from 'site-modules/shared/utils/appraiser/appraiser-validation-helper';
import { useAppraisalTabsState } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/context/appraisal-tabs-context';

/**
 * Custom hook encapsulating address-to-VIN resolution logic.
 *
 * Reads setters from context and returns the `onAddressVin` callback
 * to be passed as `updateVinAndContinue` to FindVinByAddress. Extracting
 * this logic here removes the need to prop-drill the handler through the
 * tab component tree and simplifies drawer handling in AppraisalTabsLayout.
 *
 * @returns {{ onAddressVin: Function }}
 */
export function useAddressToVin() {
  const { setVin, setMmy, setStyleIds, setIsReadyForRedirect } = useAppraisalTabsState();

  const onAddressVin = useCallback(
    (addressVin, hasVinMismatchError, vinStyles, { make, model, year }) => {
      setVin(transformVin(addressVin));
      setMmy({
        make: get(vinStyles, '[0].makeNiceId', make),
        model: get(vinStyles, '[0].modelNiceId', model),
        year: get(vinStyles, '[0].year', year),
      });
      setStyleIds(vinStyles?.map(vinStyle => vinStyle?.styleId));
      setIsReadyForRedirect(true);
    },
    [setVin, setMmy, setStyleIds, setIsReadyForRedirect]
  );

  return { onAddressVin };
}
